import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {Icon, Flex, Text} from 'components/UIKit';
import {NOOP} from 'components/UIKit/utilities';
import {NavItemData} from '../../types';
import styles from './MegaNavItem.scss';

type AnchorElementProps = JSX.IntrinsicElements['a'];
type ButtonElementProps = JSX.IntrinsicElements['button'];
type ComposedProps = AnchorElementProps & ButtonElementProps;

interface MegaNavItemProps extends ComposedProps {
  item: NavItemData;
  active?: boolean;
  onActive?: (itemPath) => any;
  itemPath?: string[];
  className?: string;
}

export class MegaNavItem extends React.PureComponent<MegaNavItemProps> {
  timeoutId?: any;

  constructor(props) {
    super(props);
    this.timeoutId = null;
  }

  handleMouseEnter = () => {
    this.timeoutId = setTimeout(this.handleActiveProxy, 300);
  };

  handleMouseLeave = () => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  };

  handleActiveProxy = () => {
    const {onActive = NOOP, itemPath} = this.props;

    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }

    onActive(itemPath);
  };

  renderLink() {
    const {item, tabIndex} = this.props;

    return (
      <a
        className={styles.item}
        href={item.url}
        itemProp="name"
        onFocus={this.handleActiveProxy}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        tabIndex={tabIndex}
        {...item.tracking}
      >
        <Flex justifyContent="space-between" alignItems="center" className={styles.label}>
          {item.prefix ? <Text type="small" text={item.prefix} resetMargin /> : null}
          <Text type="small" text={item.title} resetMargin ellipsis />
        </Flex>
      </a>
    );
  }

  renderSubMenu() {
    const {item, active = false, tabIndex} = this.props;

    return (
      <button
        className={classNames(styles.item, {[styles.active]: active})}
        itemProp="name"
        type="button"
        onClick={this.handleActiveProxy}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        tabIndex={tabIndex}
        {...item.tracking}
      >
        <Flex justifyContent="space-between" alignItems="center" className={styles.label}>
          <Text text={item.title} type="small" resetMargin ellipsis />
          <Icon
            icon="dropdown"
            size={20}
            fill="silver"
            className={classNames(styles.rightChevron, styles.icon)}
          />
        </Flex>
      </button>
    );
  }

  render() {
    const {item} = this.props;

    if (item.children.length > 0) {
      return this.renderSubMenu();
    } else {
      return this.renderLink();
    }
  }
}
